/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */
import { updateStores } from '../rules/rules-store';
import { updateDeclareExpressions } from '../expression/expression-engine';
import { parseResponse } from '../router/app-router';
import Utils from '../utils/utils';
import constants from '../constants';
import type { DxAPIResponseObject } from '../case/types';
import type { Resources } from '../rules/types';

import type { Options } from './types';

const publishMetadata = (resources: Resources) => {
  if (resources) updateStores(resources);
};

export const publishExpressions = (resources: Resources, options: Options) => {
  if (resources.DeclareExpressions && options.context) {
    updateDeclareExpressions({
      [options.context]: resources.DeclareExpressions
    });
  }
};

/**
 * Publishes other data
 * @ignore
 * @param translatedDXAPIResponse - translatedDXAPIResponse information
 * @param options - other params like context
 * @param skipParseResponse - skip Parse Response
 */
export const publishResponse = (
  translatedDXAPIResponse: DxAPIResponseObject,
  options: Options,
  skipParseResponse = false
) => {
  const resources = Utils.getIn(translatedDXAPIResponse, constants.RESOURCES);
  if (resources) {
    publishMetadata(resources);
    publishExpressions(resources, options);
  }
  if (!skipParseResponse) parseResponse({ ...translatedDXAPIResponse, options });
};
